import json from './sprite.js';

export default {
    handle: 'es_SPT9-Broken-Window-Boy',
    label: 'es_SPT9-Broken-Window-Boy',
    json,
};
